export default "__VITE_ASSET__CLWy8cYD__"